import { render, staticRenderFns } from "./selectInvoiceModal.vue?vue&type=template&id=48004fc4&scoped=true"
import script from "./selectInvoiceModal.vue?vue&type=script&lang=ts"
export * from "./selectInvoiceModal.vue?vue&type=script&lang=ts"
import style0 from "./selectInvoiceModal.vue?vue&type=style&index=0&id=48004fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48004fc4",
  null
  
)

export default component.exports